import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tent, LayoutDashboard, Award, UserCircle, ShieldCheck, LogOut, FolderOpen, Globe } from "lucide-react";

const roleLabel = { pramuka: "Pramuka", pembina: "Pembina Gudep", admin: "Admin Kwarcab" };

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  if (!user) return null;

  const links = [];
  if (user.role === "pramuka") {
    links.push({ to: "/profil", label: "Profil", icon: UserCircle, id: "nav-link-profile" });
    links.push({ to: "/prestasi", label: "Prestasi Saya", icon: Award, id: "nav-link-achievements" });
  }
  if (user.role === "pembina" || user.role === "admin") {
    links.push({ to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, id: "nav-link-dashboard" });
    links.push({ to: "/verifikasi", label: "Verifikasi", icon: ShieldCheck, id: "nav-link-verification" });
  }
  if (user.role === "admin") {
    links.push({ to: "/dokumen", label: "Dokumen", icon: FolderOpen, id: "nav-link-documents" });
    links.push({ to: "/integrasi", label: "Integrasi", icon: Globe, id: "nav-link-integration" });
  }

  const handleLogout = async () => {
    await logout();
    navigate("/auth");
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-md bg-white/90 border-b border-[#E5DFD7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to={user.role === "pramuka" ? "/profil" : "/dashboard"} className="flex items-center gap-2.5" data-testid="nav-brand-logo">
          <div className="h-9 w-9 rounded-xl bg-[#4A2E2B] flex items-center justify-center">
            <Tent className="h-5 w-5 text-[#E5A93C]" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-[#1F1917] text-sm">SIPRAM DEPOK</div>
            <div className="text-[10px] uppercase tracking-widest text-[#8C827A] font-bold">Kwarcab Kota Depok</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => {
            const active = location.pathname === l.to;
            const Icon = l.icon;
            return (
              <Link key={l.to} to={l.to} data-testid={l.id}
                className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold transition-colors ${active ? "bg-[#4A2E2B] text-white" : "text-[#4A423F] hover:bg-[#F7F4EF]"}`}>
                <Icon className="h-4 w-4" /> {l.label}
              </Link>
            );
          })}
        </div>

        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block" data-testid="nav-role-selector">
            <div className="text-sm font-semibold text-[#1F1917] leading-tight">{user.name}</div>
            <div className="text-[11px] text-[#B85C38] font-bold uppercase tracking-wide">{roleLabel[user.role]}</div>
          </div>
          <button onClick={handleLogout} data-testid="nav-logout-btn"
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold text-[#D9383A] hover:bg-rose-50 transition-colors">
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Keluar</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
